export const generateTimeFromShorthand = (value: string): string => {
  if (value.length >= 5) return value;

  // If value contains a colon, split into hours/minutes and pad
  if (value.includes(':')) {
    const [h, m] = value.split(':');
    const hours = h.padStart(2, '0');
    const minutes = m.padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  // No colon — treat digits as hours
  // 1 → 01:00, 3 → 03:00, 10 → 10:00
  if (value.length === 1) return `0${value}:00`;
  if (value.length === 2) return `${value}:00`;

  return value;
};
